import { render, staticRenderFns } from "./WorkflowActionsExtend.vue?vue&type=template&id=2206402e&scoped=true"
import script from "./WorkflowActionsExtend.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowActionsExtend.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowActionsExtend.vue?vue&type=style&index=0&id=2206402e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206402e",
  null
  
)

export default component.exports